import { useEffect, useState } from 'react'
import { api } from './api.js'

let cache = null

// The admin-editable region list, fetched once per page load.
export function useRegions() {
  const [regions, setRegions] = useState(cache ?? [])
  useEffect(() => {
    if (cache) return undefined
    let active = true
    const run = async () => {
      try {
        const data = await api('/api/regions')
        cache = data.regions
        if (active) setRegions(cache)
      } catch {
        // Forms still render; the region select just stays empty.
      }
    }
    run()
    return () => {
      active = false
    }
  }, [])
  return regions
}

// After an admin edits regions, the next useRegions() fetches them again.
export function forgetRegions() {
  cache = null
}
